import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-research-centre',
  templateUrl: './research-centre.component.html',
  styleUrls: ['./research-centre.component.scss']
})
export class ResearchCentreComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('RPCHSS - Research and Publication Center for Humanities and Social Sciences', 'facilitate and promote research work related to the academic disciplines of humanities and social sciences in a more systematic and productive manner while increasing research publications')
  }
}
